/**
 * @param {unknown} value Firestore `Timestamp` (call `toDate()`), a plain `Date`, or nullish
 * @returns {Date | null} A valid `Date`, or `null` if missing or not representable
 */
export function toDateMaybe(value) {
  if (value == null) {
    return null;
  }
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  if (typeof value.toDate === 'function') {
    const fromTs = value.toDate();
    if (!(fromTs instanceof Date) || Number.isNaN(fromTs.getTime())) {
      return null;
    }
    return fromTs;
  }
  return null;
}

/**
 * @param {unknown} value
 * @returns {number} Finite number, or 0
 */
export function toNumberOrZero(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}
